import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProtocolsDotIoComponent } from './simple-icons-protocols-dot-io.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProtocolsDotIoComponent ],
    exports:      [ SimpleIconsProtocolsDotIoComponent ],
    bootstrap:    []
})
export class SimpleIconsProtocolsDotIoModule {}
